const TOP_ANIME_COLORS = {
  1: 'bg-tp-1',
  2: 'bg-tp-2',
  3: 'bg-tp-3',
  4: 'bg-tp-4',
  5: 'bg-tp-5',
  6: 'bg-tp-6',
  7: 'bg-tp-7',
  8: 'bg-tp-8',
  9: 'bg-tp-9',
  10: 'bg-tp-10',
};

export default TOP_ANIME_COLORS;
